/* =====================================================
   FILTRO DE TALLAS POR STOCK REAL — v4
   ===================================================== */
(function () {
  'use strict';

  const SIZE_OPTION_NAME = 'talla';

  function applyStockFilter() {
    const params = new URLSearchParams(window.location.search);
    const activeFilters = [];
    params.forEach(function (value, key) {
      if (key.toLowerCase().includes('filter.v.option.' + SIZE_OPTION_NAME)) {
        activeFilters.push(value.toLowerCase().trim());
      }
    });

    document.querySelectorAll('[data-available-sizes]').forEach(function (card) {
      card.style.display = '';
      if (activeFilters.length === 0) return;

      const available = (card.getAttribute('data-available-sizes') || '')
        .split('||')
        .map(function (s) { return s.toLowerCase().trim(); })
        .filter(Boolean);

      const hasStock = activeFilters.some(function (size) {
        return available.includes(size);
      });

      if (!hasStock) card.style.display = 'none';
    });
  }

  // Correr cada 500ms — detecta cualquier cambio sin importar
  // cómo el tema cargue o reemplace las cards
  setInterval(applyStockFilter, 500);

})();


/* =====================================================
   PRESERVAR PANEL DE FILTROS ABIERTO — v7
   Estrategia: CSS !important inyectado antes de que
   Palo Alto inicialice → sus estilos inline no pueden
   sobrepasar una regla !important en stylesheet.
   ===================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'kbk_open_filters';
  var SETTLE_MS   = 4000;  // ms post window.load antes de sincronizar con click real
  var styleEl     = null;

  function getOpenIndexes() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function getAllTitles() {
    return document.querySelectorAll('.collection__filter__title');
  }

  /* ---- Inyectar CSS !important para forzar el wrapper visible ---- */
  function buildRule(id) {
    // Escapar caracteres especiales para usarlos como selector CSS
    var safe = id.replace(/([^\w-])/g, '\\$1');
    return '#' + safe + '{' +
      'display:block!important;' +
      'height:auto!important;' +
      'max-height:none!important;' +
      'overflow:visible!important;' +
      'opacity:1!important;' +
      'visibility:visible!important;' +
      'transform:none!important;' +
      'transition:none!important;' +
    '}';
  }

  function injectForceCSS(ids) {
    if (!ids.length || styleEl) return;
    styleEl = document.createElement('style');
    styleEl.id = 'kbk-filter-force';
    styleEl.textContent = ids.map(buildRule).join('');
    document.head.appendChild(styleEl);
  }

  function removeForceCSS() {
    if (styleEl && styleEl.parentNode) styleEl.parentNode.removeChild(styleEl);
    styleEl = null;
  }

  /* ---- Marcar el acordeón como abierto (sin click, sin toggle riesgo) ---- */
  function markTitleOpen(idx, titles) {
    var title = titles[idx];
    if (!title) return null;
    title.classList.add('is-expanded');
    title.setAttribute('aria-expanded', 'true');
    var wrapperId = title.getAttribute('aria-controls');
    if (wrapperId) {
      var wrapper = document.getElementById(wrapperId);
      if (wrapper) wrapper.classList.add('is-expanded');
    }
    return wrapperId || null;
  }

  /* ──────────────────────────────────────────────────────────────────────
     FASE 1 — Ejecución INMEDIATA (script defer = DOM ya existe,
     antes de DOMContentLoaded, antes de que Palo Alto inicialice
     su lógica de acordeones)
  ─────────────────────────────────────────────────────────────────────── */
  var savedIndexes = getOpenIndexes();

  if (savedIndexes.length > 0) {
    var earlyTitles = getAllTitles();
    var wrapperIds  = [];

    savedIndexes.forEach(function (idx) {
      var id = markTitleOpen(idx, earlyTitles);
      if (id) wrapperIds.push(id);
    });

    // Inyectar CSS !important ANTES de que Palo Alto pueda tocar nada.
    // Cualquier estilo inline que Palo Alto establezca después
    // (ej: height:0, display:none) será ANULADO por !important.
    injectForceCSS(wrapperIds);
  }

  /* ──────────────────────────────────────────────────────────────────────
     FASE 2 — Post-settle: Palo Alto ya terminó de inicializar.
     Hacemos click real para que registre el estado correcto,
     LUEGO quitamos el CSS forzado (con el acordeón ya abierto
     de forma nativa, sin flicker).
  ─────────────────────────────────────────────────────────────────────── */
  window.addEventListener('load', function () {
    setTimeout(function () {
      var current = getOpenIndexes();
      if (current.length === 0) { removeForceCSS(); return; }

      var titles = getAllTitles();

      // Click en los que Palo Alto haya cerrado durante su init
      current.forEach(function (idx) {
        var title = titles[idx];
        if (title && !title.classList.contains('is-expanded')) {
          title.click();
        }
      });

      // Quitar el CSS forzado después de que la animación de apertura termine
      setTimeout(removeForceCSS, 700);

    }, SETTLE_MS);
  });

  /* ──────────────────────────────────────────────────────────────────────
     GUARDAR ESTADO — antes de navegar y al interactuar con filtros
  ─────────────────────────────────────────────────────────────────────── */
  function saveState() {
    var open = [];
    getAllTitles().forEach(function (title, i) {
      if (title.classList.contains('is-expanded')) open.push(i);
    });
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(open));
  }

  // Guardar justo antes del reload (al aplicar/quitar un filtro)
  window.addEventListener('beforeunload', saveState);

  // Guardar también cuando el usuario abre/cierra un panel manualmente
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.collection__filters')) {
      setTimeout(saveState, 150);  // timeout para que el click se procese primero
    }
  });

})();





/* =====================================================
   KARIBIK — Toggle de filtros desktop (v1)
   ===================================================== */
(function () {
  'use strict';

  function initDesktopFilterToggle() {
    var section = document.querySelector('[data-section-type="collection-template"]');
    var btn = section ? section.querySelector('[data-toggle-filters-kbk]') : null;

    if (!section || !btn) return;

    btn.addEventListener('click', function (e) {
      if (window.innerWidth < 768) return;
      e.stopImmediatePropagation();
      section.classList.toggle('collection--filters-open');
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopFilterToggle);
  } else {
    initDesktopFilterToggle();
  }
})();







/* =====================================================
   KARIBIK — Grupos de tallas en filtro (v2)
   ===================================================== */
(function () {
  'use strict';

  var GRUPOS = {
    'Superior': ['xxxs', 'xxs', 'xs', 's', 'm', 'l', 'xl'],
    'Inferior': ['02', '04', '06', '08', '10', '12', '14'],
    'Zapatos':  ['34', '35', '36', '37', '38', '39', '40']
  };
  var ORDEN = ['Superior', 'Inferior', 'Zapatos'];

  var TALLA_GRUPO = {};
  ORDEN.forEach(function (g) {
    GRUPOS[g].forEach(function (t) { TALLA_GRUPO[t] = g; });
  });

  function getGrupo(texto) {
    return TALLA_GRUPO[texto.toLowerCase().trim()] || null;
  }

  function organizarTallas() {
    document.querySelectorAll('.collection__filter').forEach(function (filtro) {

      // Verificar que es el filtro de Talla
      var span = filtro.querySelector('.collection__filter__title span');
      if (!span) return;
      if (!span.textContent.toLowerCase().includes('talla')) return;

      // Recoger TODOS los li de talla (incluyendo los del "ver más")
      var todosLos = Array.from(filtro.querySelectorAll('li.collection__filter-tag'));
      if (!todosLos.length) return;

      // Verificar que contiene tallas reales
      var hasTallas = todosLos.some(function (li) {
        var label = li.querySelector('label.filter__button');
        return label && getGrupo(label.textContent.trim()) !== null;
      });
      if (!hasTallas) return;

      // Lista principal
      var lista = filtro.querySelector('ul[data-collapsible-content]');
      if (!lista) return;

      // Quitar etiquetas previas si ya se aplicó
      filtro.querySelectorAll('.kbk-grupo-talla').forEach(function (el) { el.remove(); });

      // Agrupar items
      var porGrupo = {};
      var otros = [];
      ORDEN.forEach(function (g) { porGrupo[g] = []; });

      todosLos.forEach(function (li) {
        var label = li.querySelector('label.filter__button');
        var texto = label ? label.textContent.trim() : '';
        var g = getGrupo(texto);
        if (g) { porGrupo[g].push(li); }
        else { otros.push(li); }
      });

      // Limpiar lista principal y quitar contenedor "ver más" si existe
      lista.innerHTML = '';
      var showMoreContainer = filtro.querySelector('.collection__filter-actions');
      if (showMoreContainer) showMoreContainer.remove();

      // Reconstruir con cabeceras
      ORDEN.forEach(function (grupo) {
        if (!porGrupo[grupo].length) return;
        var cab = document.createElement('li');
        cab.className = 'kbk-grupo-talla';
        cab.textContent = grupo;
        lista.appendChild(cab);
        porGrupo[grupo].forEach(function (li) { lista.appendChild(li); });
      });
      otros.forEach(function (li) { lista.appendChild(li); });
    });
  }

    
  







    // Ejecutar en carga inicial
  setTimeout(organizarTallas, 500);
  setTimeout(organizarTallas, 1500);

  // --- Guardar qué paneles están abiertos antes de cada AJAX ---
  var _kbkOpenTitles = [];

  function guardarPanelesAbiertos() {
    _kbkOpenTitles = [];
    document.querySelectorAll('[data-collapsible-trigger]').forEach(function(t) {
      if (t.classList.contains('is-expanded')) {
        var s = t.querySelector('span');
        if (s) _kbkOpenTitles.push(s.textContent.trim());
      }
    });
  }

    function restaurarPanelesAbiertos() {
    if (!_kbkOpenTitles.length) return;
    setTimeout(function() {
      document.querySelectorAll('[data-collapsible-trigger]').forEach(function(t) {
        var s = t.querySelector('span');
        if (!s) return;
        var actualBase = s.textContent.trim().toLowerCase().replace(/\s*\(\d+\)/g, '').trim();
        var match = _kbkOpenTitles.some(function(titulo) {
          return titulo.toLowerCase().replace(/\s*\(\d+\)/g, '').trim() === actualBase;
        });
        if (match && !t.classList.contains('is-expanded')) {
          t.click();
        }
      });
    }, 300);
  }

  // Guardar estado justo antes de que el AJAX reemplace el HTML
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-collection-filters]')) {
      guardarPanelesAbiertos();
    }
  });

  // Detectar cuando Palo Alto recarga los filtros vía AJAX y re-aplicar grupos
  function initGrupoObserver() {
    var panel = document.querySelector('[data-collection-filters]');
    if (!panel) { setTimeout(initGrupoObserver, 500); return; }
    var debounceTimer;
    var obs = new MutationObserver(function () {
      clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function() {
        organizarTallas();
        restaurarPanelesAbiertos();
      }, 50);
    });
    obs.observe(panel, { childList: true });
  }
  initGrupoObserver();
})();